import { db } from "@/firebase";
import {
  BUSINESS,
  RESTAURANTS,
  FOODS,
  LOCATIONS,
  CONFIG,
  COUNTRIES,
  STATES,
  MUNICIPALITIES,
  CITIES,
} from "@/config/data/parameters";
import {
  getDocs,
  collection,
  doc,
  query,
  where,
  setDoc,
  Timestamp,
  getDoc,
  orderBy,
  startAt,
  endAt,
} from "firebase/firestore/lite";
import {
  getCurrentDateSeconds,
  getCurrentWeekMinute,
  getHumanSchedule,
} from "./filters";
const geofire = require("geofire-common");

let displayedIds: Record<string, Set<string>> = {};
let currentStepIndex: Record<string, number> = {};
const RADIO_STEPS = [0.1, 0.2, 0.3, 3, 5, 10];
const RADIO = Number(process.env.VUE_APP_RADIO ?? 3);
const DAY_OFFSETS: Record<string, number> = {
  Lunes: 0,
  Martes: 1440,
  Miercoles: 2880,
  Jueves: 4320,
  Viernes: 5760,
  Sabado: 7200,
  Domingo: 8640,
};
const DIA = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miercoles",
  "Jueves",
  "Viernes",
  "Sabado",
];

function extractCoordsFromUrl(url: string) {
  // Busca patrones de números decimales separados por coma
  const regex = /@?(-?\d+\.\d+),(-?\d+\.\d+)/;
  const match = regex.exec(url);

  if (match) {
    return {
      latitude: Number.parseFloat(match[1]),
      longitude: Number.parseFloat(match[2]),
    };
  }
  return null;
}

async function addN(negocio: any) {
  let geo = extractCoordsFromUrl(negocio.ubicacion);
  const hash = geofire.geohashForLocation([geo!.latitude, geo!.longitude]);

  let n = negocio;
  const schedule = transformMapScheduleToIntervals(n.horario);
  const human_schedule = getHumanSchedule(schedule);
  let data = {
    active: true,
    city_id: "LOC-MX-CAM-002",
    city_name: n.city_name,
    has_takeout: n.comida_llevar || false,
    has_dine_in: n.comida_local || false,
    has_delivery: n.domicilio || false,
    delivery_description: n.domicilio_descripcion || "",
    schedule: schedule,
    human_schedule: human_schedule,
    id: negocio.id,
    front_page_image: n.front_page_image,
    calls: n.llamadas || 0,
    call_view: n.llamadas_publico,
    creation_date: Timestamp.fromDate(new Date()),
    logo: n.logo,
    name: n.nombre,
    status: n.status,
    g: {
      geohash: hash,
      geopoint: geo,
      maps: n.ubicacion,
    },
  };
  setDoc(doc(db, BUSINESS, negocio.id), data);
  // setDoc(doc(db, BUSINESS, "zP41l5TEH4oytXqokWO2", RESTAURANTS, negocio.id), n);
}

async function addState() {
  const id_country = "MX";
  const estadosMexico = [
    {
      id: "MX-AGU",
      name: "Aguascalientes",
      zip_code: "20000",
      g: { geohash: "9gbp9", geopoint: [21.8853, -102.2916] },
    },
    {
      id: "MX-BCN",
      name: "Baja California",
      zip_code: "21000",
      g: { geohash: "9mv77", geopoint: [32.6278, -115.4545] },
    },
    {
      id: "MX-BCS",
      name: "Baja California Sur",
      zip_code: "23000",
      g: { geohash: "9ms6e", geopoint: [24.1426, -110.3128] },
    },
    {
      id: "MX-CAM",
      name: "Campeche",
      zip_code: "24000",
      g: { geohash: "9gj3f", geopoint: [19.8301, -90.5349] },
    },
    {
      id: "MX-CHP",
      name: "Chiapas",
      zip_code: "29000",
      g: { geohash: "9fycj", geopoint: [16.7569, -93.1292] },
    },
    {
      id: "MX-CHH",
      name: "Chihuahua",
      zip_code: "31000",
      g: { geohash: "9ts6s", geopoint: [28.633, -106.0691] },
    },
    {
      id: "MX-CMX",
      name: "Ciudad de México",
      zip_code: "06000",
      g: { geohash: "9g3vx", geopoint: [19.4326, -99.1332] },
    },
    {
      id: "MX-COA",
      name: "Coahuila",
      zip_code: "25000",
      g: { geohash: "9u86j", geopoint: [25.4232, -101.0053] },
    },
    {
      id: "MX-COL",
      name: "Colima",
      zip_code: "28000",
      g: { geohash: "9evf1", geopoint: [19.2433, -103.725] },
    },
    {
      id: "MX-DUR",
      name: "Durango",
      zip_code: "34000",
      g: { geohash: "9sy3v", geopoint: [24.0277, -104.6532] },
    },
    {
      id: "MX-GUA",
      name: "Guanajuato",
      zip_code: "36000",
      g: { geohash: "9gc0u", geopoint: [21.019, -101.2574] },
    },
    {
      id: "MX-GRO",
      name: "Guerrero",
      zip_code: "39000",
      g: { geohash: "9g1y1", geopoint: [17.5513, -99.5005] },
    },
    {
      id: "MX-HID",
      name: "Hidalgo",
      zip_code: "42000",
      g: { geohash: "9g3z1", geopoint: [20.1011, -98.7591] },
    },
    {
      id: "MX-JAL",
      name: "Jalisco",
      zip_code: "44100",
      g: { geohash: "9p5f8", geopoint: [20.6767, -103.3473] },
    },
    {
      id: "MX-MEX",
      name: "México",
      zip_code: "50000",
      g: { geohash: "9g3qj", geopoint: [19.2827, -99.6557] },
    },
    {
      id: "MX-MIC",
      name: "Michoacán",
      zip_code: "58000",
      g: { geohash: "9g95v", geopoint: [19.7008, -101.1846] },
    },
    {
      id: "MX-MOR",
      name: "Morelos",
      zip_code: "62000",
      g: { geohash: "9g3tc", geopoint: [18.922, -99.2341] },
    },
    {
      id: "MX-NAY",
      name: "Nayarit",
      zip_code: "63000",
      g: { geohash: "9shre", geopoint: [21.5039, -104.8946] },
    },
    {
      id: "MX-NLE",
      name: "Nuevo León",
      zip_code: "64000",
      g: { geohash: "9u89e", geopoint: [25.6866, -100.3161] },
    },
    {
      id: "MX-OAX",
      name: "Oaxaca",
      zip_code: "68000",
      g: { geohash: "9g4n6", geopoint: [17.0732, -96.7266] },
    },
    {
      id: "MX-PUE",
      name: "Puebla",
      zip_code: "72000",
      g: { geohash: "9g6h3", geopoint: [19.0414, -98.2063] },
    },
    {
      id: "MX-QUE",
      name: "Querétaro",
      zip_code: "76000",
      g: { geohash: "9g9wv", geopoint: [20.5888, -100.3899] },
    },
    {
      id: "MX-ROO",
      name: "Quintana Roo",
      zip_code: "77000",
      g: { geohash: "9gbvj", geopoint: [18.5036, -88.3053] },
    },
    {
      id: "MX-SLP",
      name: "San Luis Potosí",
      zip_code: "78000",
      g: { geohash: "9gcdx", geopoint: [22.1565, -100.9855] },
    },
    {
      id: "MX-SIN",
      name: "Sinaloa",
      zip_code: "80000",
      g: { geohash: "9sm6q", geopoint: [24.8091, -107.394] },
    },
    {
      id: "MX-SON",
      name: "Sonora",
      zip_code: "83000",
      g: { geohash: "9t64n", geopoint: [29.073, -110.9559] },
    },
    {
      id: "MX-TAB",
      name: "Tabasco",
      zip_code: "86000",
      g: { geohash: "9gfz4", geopoint: [17.9892, -92.9475] },
    },
    {
      id: "MX-TAM",
      name: "Tamaulipas",
      zip_code: "87000",
      g: { geohash: "9ud8m", geopoint: [23.7369, -99.1411] },
    },
    {
      id: "MX-TLA",
      name: "Tlaxcala",
      zip_code: "90000",
      g: { geohash: "9g6ju", geopoint: [19.3182, -98.2375] },
    },
    {
      id: "MX-VER",
      name: "Veracruz",
      zip_code: "91000",
      g: { geohash: "9g6w7", geopoint: [19.5438, -96.9102] },
    },
    {
      id: "MX-YUC",
      name: "Yucatán",
      zip_code: "97000",
      g: { geohash: "9gxng", geopoint: [20.9674, -89.5926] },
    },
    {
      id: "MX-ZAC",
      name: "Zacatecas",
      zip_code: "98000",
      g: { geohash: "9gc8v", geopoint: [22.7709, -102.5832] },
    },
  ];
  estadosMexico.forEach(async (e) => {
    setDoc(doc(db, CONFIG, LOCATIONS, STATES, e.id), {
      ...e,
      country_id: id_country,
    });
  });
  addMuni();
}

async function addCountry() {
  const paisesNorteamerica = [
    {
      id: "MX",
      name: "México",
      zip_code: "06000",
      g: { geohash: "9g3vx", geopoint: [19.4326, -99.1332] },
    },
    {
      id: "US",
      name: "Estados Unidos",
      zip_code: "20001",
      g: { geohash: "dqcjr", geopoint: [38.8951, -77.0364] },
    },
    {
      id: "CA",
      name: "Canadá",
      zip_code: "K1P",
      g: { geohash: "f241e", geopoint: [45.4215, -75.6972] },
    },
  ];
  paisesNorteamerica.forEach(async (n) => {
    setDoc(doc(db, CONFIG, LOCATIONS, COUNTRIES, n.id), n);
  });
  addState();
}

async function addMuni() {
  const municipiosMexico = [
    {
      // ID: MUN + PAIS + ESTADO + CLAVE_INEGI (009)
      id: "MUN-CAM-009",
      name: "Escárcega",
      state_id: "MX-CAM",
      zip_code: "24350",
      g: {
        geohash: "9gh6k",
        geopoint: [18.6089, -90.7454],
      },
    },
    {
      // ID: MUN + PAIS + ESTADO + CLAVE_INEGI (012)
      id: "MUN-CAM-012",
      name: "Seybaplaya",
      state_id: "MX-CAM",
      zip_code: "24440",
      g: {
        geohash: "9gj1s",
        geopoint: [19.6375, -90.6436],
      },
    },
    {
      id: "MUN-CAM-002", // Formato: MUN - ESTADO - CLAVE_INEGI
      name: "Champotón",
      state_id: "MX-CAM", // Vinculado a Campeche
      zip_code: "24400",
      g: {
        geohash: "9gj14",
        geopoint: [19.3517, -90.7208],
      },
    },
    {
      id: "MUN-YUC-050",
      name: "Mérida",
      state_id: "MX-YUC", // Vinculado a Yucatán
      zip_code: "97000",
      g: {
        geohash: "9gxng",
        geopoint: [20.9674, -89.5926],
      },
    },
    {
      id: "MUN-YUC-056",
      name: "Muna",
      state_id: "MX-YUC",
      zip_code: "97840",
      g: {
        geohash: "9gxtm",
        geopoint: [20.4878, -89.7139],
      },
    },
  ];
  municipiosMexico.forEach(async (m) => {
    setDoc(doc(db, CONFIG, LOCATIONS, MUNICIPALITIES, m.id), m);
  });
  addCity();
}

async function addCity() {
  const locations_southeast = [
    // --- CAMPECHE ---
    {
      id: "LOC-MX-CAM-002",
      name: "Champotón",
      state_id: "MX-CAM",
      municipality_id: "MUN-MX-CAM-002",
      zip_code: "24400",
      g: { geohash: "9gj14", geopoint: [19.3517, -90.7208] },
    },
    {
      id: "LOC-MX-CAM-002",
      name: "Villamadero",
      state_id: "MX-CAM",
      municipality_id: "MUN-MX-CAM-002", // Pertenece a Champotón
      zip_code: "24410",
      g: { geohash: "9gj1e", geopoint: [19.5397, -90.6861] },
    },
    {
      id: "LOC-MX-CAM-009",
      name: "Escárcega",
      state_id: "MX-CAM",
      municipality_id: "MUN-MX-CAM-009",
      zip_code: "24350",
      g: { geohash: "9gh6k", geopoint: [18.6089, -90.7454] },
    },
    {
      id: "LOC-MX-CAM-001",
      name: "San Francisco de Campeche",
      state_id: "MX-CAM",
      municipality_id: "MUN-MX-CAM-001",
      zip_code: "24000",
      g: { geohash: "9gj3f", geopoint: [19.8301, -90.5349] },
    },
    {
      id: "LOC-MX-CAM-012",
      name: "Seybaplaya",
      state_id: "MX-CAM",
      municipality_id: "MUN-MX-CAM-012", // Municipio autónomo desde 2021
      zip_code: "24440",
      g: { geohash: "9gj1s", geopoint: [19.6375, -90.6436] },
    },
    {
      id: "LOC-MX-CAM-002",
      name: "Villamar",
      state_id: "MX-CAM",
      municipality_id: "MUN-MX-CAM-002",
      zip_code: "24400",
      g: { geohash: "9gj14", geopoint: [19.3444, -90.7161] },
    },

    // --- YUCATÁN ---
    {
      id: "LOC-MX-YUC-050",
      name: "Mérida",
      state_id: "MX-YUC",
      municipality_id: "MUN-MX-YUC-050",
      zip_code: "97000",
      g: { geohash: "9gxng", geopoint: [20.9674, -89.5926] },
    },
    {
      id: "LOC-MX-YUC-050-CAUCEL",
      name: "Ciudad Caucel",
      state_id: "MX-YUC",
      municipality_id: "MUN-MX-YUC-050", // Parte de Mérida
      zip_code: "97314",
      g: { geohash: "9gxn9", geopoint: [20.9994, -89.7422] },
    },
    {
      id: "LOC-MX-YUC-056",
      name: "Muna",
      state_id: "MX-YUC",
      municipality_id: "MUN-MX-YUC-056",
      zip_code: "97840",
      g: { geohash: "9gxtm", geopoint: [20.4878, -89.7139] },
    },
    {
      id: "LOC-MX-YUC-044",
      name: "Kanasín",
      state_id: "MX-YUC",
      municipality_id: "MUN-MX-YUC-044",
      zip_code: "97370",
      g: { geohash: "9gxpx", geopoint: [20.9344, -89.5583] },
    },
    {
      id: "LOC-MX-YUC-091",
      name: "Umán",
      state_id: "MX-YUC",
      municipality_id: "MUN-MX-YUC-091",
      zip_code: "97390",
      g: { geohash: "9gxn6", geopoint: [20.8825, -89.7469] },
    },
  ];
  locations_southeast.forEach(async (l) => {
    setDoc(doc(db, CONFIG, LOCATIONS, CITIES, l.id), l);
  });
}

function transformMapScheduleToIntervals(oldSchedule: Record<string, any>) {
  let intervals: Array<{ start: number; end: number }> = [];

  // Usamos Object.keys para iterar sobre los nombres de los días (Lunes, Martes...)
  Object.keys(oldSchedule).forEach((dayName) => {
    const dayOffset = DAY_OFFSETS[dayName];
    const dayData = oldSchedule[dayName]; // Esto es el Array o Map de turnos

    // Iteramos sobre los turnos (0, 1, etc.) dentro de cada día
    Object.keys(dayData).forEach((turnKey) => {
      const turn = dayData[turnKey]; // Aquí accedemos a {open: "11:00", closed: "23:59"}

      // Convertimos los strings "HH:mm" a minutos totales
      const [openH, openM] = turn.open.split(":").map(Number);
      const [closeH, closeM] = turn.closed.split(":").map(Number);

      let start = dayOffset + openH * 60 + openM;
      let end = dayOffset + closeH * 60 + closeM;

      // LÓGICA DE MADRUGADA:
      // Si la hora de cierre es numéricamente menor a la de apertura,
      // sumamos 24 horas (1440 min) porque cerró al día siguiente.
      if (end <= start) {
        end += 1440;
      }

      intervals.push({ start, end });
    });
  });

  // Ordenamos de menor a mayor para que las consultas sean consistentes
  return intervals.sort((a, b) => a.start - b.start);
}

async function addP(platillo: any, id_negocio: string) {
  setDoc(
    doc(
      db,
      BUSINESS,
      "zP41l5TEH4oytXqokWO2",
      RESTAURANTS,
      id_negocio,
      FOODS,
      platillo.id,
    ),
    platillo,
  );
}

async function createFood() {
  let negocio = "tequeria-el-perrito";
  // multi_s
  // multi_a
  // only_one
  let ingre_2 = [
    {
      type: "multi_s",
      title: "Personaliza tu pedido",
      id: "C1",
      config: {
        minimo: 1,
        maximo: 2,
        require: false,
      },
      content: [
        {
          option_name: "Sin cebolla",
          price: 0,
          id: "A0",
        },
        {
          option_name: "Sin repollo",
          price: 0,
          id: "A1",
        },
        {
          option_name: "Sin queso",
          price: 0,
          id: "A3",
        },
      ],
    },
    {
      type: "only_one",
      title: "Selecciona tu descuento",
      id: "C2",
      config: {
        minimo: 1,
        maximo: 1,
        require: true,
      },
      content: [
        {
          option_name: "Rebanada de pastel",
          price: 5,
          id: "A0",
        },
        {
          option_name: "Brownie",
          price: 0,
          id: "A1",
        },
        {
          option_name: "Combo sorpresa",
          price: 10,
          id: "A3",
        },
      ],
    },
    {
      type: "multi_s",
      title: "Dale mas sabor a tu pedido",
      id: "C3",
      config: {
        minimo: 1,
        maximo: 2,
        require: false,
      },
      content: [
        {
          option_name: "Doble carne",
          price: 15,
          id: "A0",
        },
        {
          option_name: "Doble queso",
          price: 10,
          id: "A1",
        },
        {
          option_name: "Extra ingrediente secreto",
          price: 25,
          id: "A3",
        },
      ],
    },
    {
      type: "multi_a",
      title: "Refresca tu sed",
      id: "C4",
      config: {
        minimo: 0,
        maximo: 30,
        require: false,
      },
      content: [
        {
          option_name: "Agua de tamarindo 500ml",
          price: 15,
          id: "A0",
        },
        {
          option_name: "Agua de guanabana 500ml",
          price: 15,
          id: "A1",
        },
        {
          option_name: "Agua de tamarindo 2.5L",
          price: 60,
          id: "A3",
        },
        {
          option_name: "Agua de guanabana 2.5L",
          price: 60,
          id: "A1",
        },
      ],
    },
  ];
  setDoc(
    doc(
      db,
      BUSINESS,
      "zP41l5TEH4oytXqokWO2",
      RESTAURANTS,
      negocio,
      FOODS,
      "gytfv8dg84ad6g666fg50",
    ),
    {
      nombre: "Mega taquito de pastor",
      descripcion:
        "Mega taquito de pastor con salsa extra picante para los meros meros",
      imagen:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8QceJTI2x92ZuXUVH7yAp9c6ywyf3GQUAAQ&usqp=CAU",
      precio: 50.0,
      ingredients: ingre_2,
    },
  );
  setDoc(
    doc(
      db,
      BUSINESS,
      "zP41l5TEH4oytXqokWO2",
      RESTAURANTS,
      negocio,
      FOODS,
      "gytfv8dg84ad6g666fg51",
    ),
    {
      nombre: "Taquito salvaje",
      descripcion: "Un taco indomable con la valentia de un guerrero azteca.",
      imagen:
        "https://media-cdn.tripadvisor.com/media/photo-s/1b/4e/e5/26/taco-estilo-baja-tempurado.jpg",
      precio: 15.0,
      ingredients: ingre_2,
    },
  );
  setDoc(
    doc(
      db,
      BUSINESS,
      "zP41l5TEH4oytXqokWO2",
      RESTAURANTS,
      negocio,
      FOODS,
      "gytfv8dg84ad6g666fg52",
    ),
    {
      nombre: "Mega tranca triple doble jumbo",
      descripcion:
        "El que no conoce a dios, a cualquier santo le resa, megra tranca de 3 kg con mega choriso argentino, pierna de unicorno y cola de T-Rex.",
      imagen:
        "https://www.vvsupremo.com/wp-content/uploads/2018/06/Mega-Torta-900x570.jpg",
      precio: 190.0,
      ingredients: ingre_2,
    },
  );
  setDoc(
    doc(
      db,
      BUSINESS,
      "zP41l5TEH4oytXqokWO2",
      RESTAURANTS,
      negocio,
      FOODS,
      "gytfv8dg84ad6g666fg53",
    ),
    {
      nombre: "Gringa divina",
      descripcion:
        "Termina con tu hambre por 7 días como si fuera un milagro con el poder saciante de esta suculenta gringa con carne misteriosamente exquisita",
      imagen:
        "https://revistaprimeraluz.files.wordpress.com/2018/02/fe-y-razon.png",
      precio: 80,
      ingredients: ingre_2,
    },
  );
  setDoc(
    doc(
      db,
      BUSINESS,
      "zP41l5TEH4oytXqokWO2",
      RESTAURANTS,
      negocio,
      FOODS,
      "gytfv8dg84ad6g666fg54",
    ),
    {
      nombre: "Gringa diabolica",
      descripcion: "Termina con tu hambre por 30 días",
      imagen:
        "https://cloudfront-us-east-1.images.arcpublishing.com/metroworldnews/E3ECCVPWVFCOPNNLFX4TJPKVWM.jpg",
      precio: 800,
      ingredients: ingre_2,
    },
  );
}

async function transportFood(food: any, id_negocio: string) {
  const new_food = {
    id: food.id,
    name: food.nombre,
    description: food.descripcion,
    price: food.precio,
    image: food.imagen,
  };
  setDoc(doc(db, BUSINESS, id_negocio, FOODS, food.id), new_food);
}

function _isBusinessOpen(intervals: Array<any>, currentMinutes: number) {
  return intervals.some((interval) => {
    // Caso normal: El intervalo está dentro de la misma semana
    if (currentMinutes >= interval.start && currentMinutes <= interval.end)
      return true;

    // Caso especial: El negocio abrió el domingo y sigue abierto el lunes madrugada
    // Si el 'end' es mayor a 10080, revisamos el remanente al principio de la semana
    if (interval.end > 10080) {
      const leftover = interval.end - 10080;
      if (currentMinutes <= leftover) return true;
    }

    return false;
  });
}

async function getSpecificFood(food_id: string, id_restaurant: string) {
  try {
    const foodRef = doc(db, BUSINESS, id_restaurant, FOODS, food_id);
    let Food = await getDoc(foodRef);
    if (Food.exists()) {
      const data = {
        id: food_id,
        ...Food.data(),
      };
      return data;
    }
  } catch (error) {
    console.log(error);
  }
}

async function getAllRestaurantFood(id_negocio: string) {
  let result = {
    array: [] as any[],
    object: {} as Record<string, any>,
  };
  try {
    let Foods = await getDocs(collection(db, BUSINESS, id_negocio, FOODS));
    Foods.forEach((doc) => {
      let info: any = doc.data();
      result.array.push(info);
      result.object[info.id] = info;
    });
  } catch (error) {
    console.log(error);
  }
  return result;
}

async function getLocalBusinessNextPage(
  userLocation: [number, number],
  location_id: string,
) {
  if (!currentStepIndex[location_id]) {
    currentStepIndex[location_id] = 0;
  }

  if (!displayedIds[location_id]) {
    displayedIds[location_id] = new Set();
  }

  const displayed = displayedIds[location_id];

  let step = currentStepIndex[location_id];
  while (step < RADIO_STEPS.length) {
    const radius = RADIO_STEPS[step];
    console.log('Step: ', radius);

    const results = await _getLocalBusinessByRadio(userLocation, radius);

    const newResults = results.filter((biz) => !displayed.has(biz.id));

    if (newResults.length >= 4) {
      newResults.forEach((biz) => displayed.add(biz.id));
      currentStepIndex[location_id] = step + 1;
      return newResults;
    }

    step++;
  }
  console.log("No hay más restaurantes en el área máxima");
  return [];
}

async function getLocalBusiness(
  userLocation: [number, number],
  location_id: string,
) {
  if (!currentStepIndex[location_id]) {
    currentStepIndex[location_id] = 0;
  }

  if (!displayedIds[location_id]) {
    displayedIds[location_id] = new Set();
  }

  const displayed = displayedIds[location_id];

  if (displayed.size > 0) {
    console.log("No hay más restaurantes en el área");
    return [];
  }

  const results = await _getLocalBusinessByRadio(userLocation, RADIO);

  results.forEach((biz) => displayed.add(biz.id));
  return results;
}

async function getSpecificBusiness(id_business: string) {
  try {
    const businessRef = doc(db, BUSINESS, id_business);
    let business = await getDoc(businessRef);
    if (business.exists()) {
      const data = {
        id: business.id,
        ...business.data(),
      };
      return data;
    }
  } catch (error) {
    console.log(error);
  }
  return null;
}

async function getAllBusiness1(city_id: string, activo = true) {
  let result = {
    array: [] as any[],
    array_new: [] as any[],
    object: {} as Record<string, any>,
  };
  try {
    let current_date_number_string = new Date()
      .toLocaleTimeString("en-US", { hour12: false })
      .replace(":", "");
    let current_date_number = Number.parseInt(current_date_number_string);
    let current_day = DIA[new Date().getDay()];
    let q = activo
      ? query(
          collection(db, BUSINESS, city_id, RESTAURANTS),
          where("activo", "==", true),
        )
      : query(collection(db, BUSINESS, city_id, RESTAURANTS));
    let business = await getDocs(q);
    let current_date = getCurrentDateSeconds();
    business.forEach((doc) => {
      let info = doc.data();
      // addN(info);
      if (info.horario) {
        let horario = info.horario[current_day];
        if (!horario || horario.length == 0) {
          info["status"] = "Cerrado";
          info["color_status"] = "#FF5252";
        } else {
          if (horario.length == 1) {
            if (
              getOpen(horario[0]) < current_date_number &&
              getClosed(horario[0]) > current_date_number
            ) {
              info["status"] = "Abierto";
              info["color_status"] = "#4CAF50";
            } else {
              info["status"] = "Cerrado";
              info["color_status"] = "#FF5252";
            }
          } else {
            for (let i = 0; i < horario.length; i++) {
              if (
                getOpen(horario[i]) < current_date_number &&
                getClosed(horario[i]) > current_date_number
              ) {
                info["status"] = "Abierto";
                info["color_status"] = "#4CAF50";
                i = horario.length + 1;
              } else {
                info["status"] = "Cerrado";
                info["color_status"] = "#FF5252";
              }
            }
          }
        }
      } else {
        info["status"] = "Sin Verificar";
        info["color_status"] = "#2196F3";
      }
      result.array.push(info);
      result.object[info.id] = info;
      let diferencia = current_date - info.creation_date.seconds;
      if (diferencia < 604800) {
        result.array_new.push(info);
      }
    });
  } catch (error) {
    console.log(error);
  }
  return result;
}

function _getStatusInformation(schedule: any, currentDate: number) {
  if (!schedule) {
    return { status: "Sin Verificar", color_status: "#2196F3" };
  }

  const is_open = _isBusinessOpen(schedule, currentDate);
  return {
    status: is_open ? "Abierto" : "Cerrado",
    color_status: is_open ? "#4CAF50" : "#FF5252",
  };
}

function _processBusinessData(
  info: any,
  userLocation: [number, number],
  currentDate: number,
) {
  const { g, schedule } = info;
  if (!g?.geopoint) return null;

  const distanceInKm = geofire.distanceBetween(
    [g.geopoint.latitude, g.geopoint.longitude],
    userLocation,
  );

  // Determinamos el estado visual
  const statusInfo = _getStatusInformation(schedule, currentDate);

  return {
    ...info,
    ...statusInfo,
    distance: distanceInKm.toFixed(2),
    distanceInM: distanceInKm * 1000, // Para el filtrado posterior
  };
}

async function _getLocalBusinessByRadio(
  userLocation: [number, number], // Usamos tupla para mayor precisión
  radiusKm: number = 0,
  activo = true,
) {
  const radiusInM = radiusKm * 1000;
  const bounds: Array<[string, string]> = geofire.geohashQueryBounds(
    userLocation,
    radiusInM,
  );
  // 1. Generar y ejecutar promesas de forma limpia
  const promises = bounds.map(([start, end]) => {
    const constraints: any[] = [];
    if (activo) constraints.push(where("active", "==", true));
    constraints.push(orderBy("g.geohash"), startAt(start), endAt(end));

    const q = query(collection(db, BUSINESS), ...constraints);
    return getDocs(q);
  });

  const snapshots = await Promise.all(promises);
  const current_date = getCurrentWeekMinute();

  // 2. Procesar y filtrar resultados usando pipelines funcionales
  const result = snapshots
    .flatMap((snap) => snap.docs)
    .map((doc) => _processBusinessData(doc.data(), userLocation, current_date))
    .filter((business) => business && business.distanceInM <= radiusInM);
  return result;
}

function getClosed(horario: any) {
  return Number.parseInt(horario.closed.replace(":", ""));
}
function getOpen(horario: any) {
  return Number.parseInt(horario.open.replace(":", ""));
}

export {
  getAllBusiness1,
  getLocalBusinessNextPage,
  getLocalBusiness,
  createFood,
  getAllRestaurantFood,
  getSpecificFood,
  getSpecificBusiness,
  addN,
  addP,
};
